// 默认的代码模板
export const CODE_TEMPLATES = {
  cpp: {
    code: `#include <iostream>
using namespace std;
int main() {
  cout << "Hello, World!" << endl;
  return 0;
}`,
    fileName: 'HelloC++'
  },
  python: {
    code: `print("Hello, World!")`,
    fileName: 'hello.py'
  }
} as const;

export type Language = keyof typeof CODE_TEMPLATES;

interface LanguageTemplate {
  code: string;
  fileName: string;
}

/**
 * 获取指定语言的代码模板和默认文件名
 * @param language 编程语言
 * @returns 包含代码和文件名的对象
 */
export function getLanguageTemplate(language: Language): LanguageTemplate {
  return CODE_TEMPLATES[language] || CODE_TEMPLATES.cpp;
}

/**
 * 判断是否是支持的语言类型
 * @param language 要检查的语言
 * @returns 是否是支持的语言
 */
export function isSupportedLanguage(language: string): language is Language {
  return language in CODE_TEMPLATES;
}

/**
 * 获取默认语言
 * @returns 默认语言
 */
export function getDefaultLanguage(): Language {
  return 'cpp';
}
